import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import { Icons } from "../icons/icons"
import { DirectionBox } from "./post-navigation"

export const AuthorBox: React.FC<{
  name?: string
  url?: string
  position?: string
  description?: string
}> = ({ name, url, position, description }) => {
  return (
    <AuthorBoxDiv>
      <Link to={`/author/${name}/all`} style={{ height: 100 }}>
        <AuthorImageContainer>
          <AuthorImage src={url} alt={`author img for ${name}`} />
        </AuthorImageContainer>
      </Link>
      <AuthorInfoContainer>
        <Link to={`/author/${name}/all`} style={{ color: "inherit" }}>
          {name && <AuthorName>{name}</AuthorName>}
        </Link>
        {/* {position && <AuthorPosition>{position}</AuthorPosition>} */}
        {description && <AuthorDescription>{description}</AuthorDescription>}

        <Link
          to={`/author/${name}/all`}
          style={{ color: "inherit", alignSelf: "end", marginTop: 8 }}
        >
          <DirectionBox prev>
            <p>記事一覧</p>
            <Icons.CategoryChevron
              width={12}
              direction={"right"}
              changeColorOnActive
              activeColor="#ef7a00"
            />
          </DirectionBox>
        </Link>
      </AuthorInfoContainer>
    </AuthorBoxDiv>
  )
}

const AuthorBoxDiv = styled.div`
  background: #f4f4f4;
  padding: 40px;
  display: flex;
  justify-content: flex-start;
  gap: 40px;
  margin-bottom: 40px;
  /* SP style */
  @media screen and (max-width: 767px) {
    padding: 16px;
  }
`

const AuthorImage = styled.img<{ image?: string }>`
  border-radius: 66px;
  flex: 0 0 100px;
  max-width: 100%;
  width: 100px;
  height: 100px;
  background-size: cover;
  /* SP style */
  @media screen and (max-width: 767px) {
    flex: 0 0 60px;
    width: 60px;
    height: 60px;
    margin: 10px;
    margin-right: 22px;
  }
`

const AuthorImageContainer = styled.div`
  width: 100px;
  height: 100px;
`

const AuthorInfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-start;
`

const AuthorName = styled.div`
  font-size: 18px;
  font-weight: bold;
  opacity: 0.8;
  margin-bottom: 8px;
`

// const AuthorPosition = styled.h2`
//   font-size: 12px;
//   font-weight: normal;
//   opacity: 0.5;
//   margin-bottom: 2px;
//   text-indent: 12px;
// `

const AuthorDescription = styled.p`
  font-size: 13px;
  line-height: 2;
  text-indent: 8px;
  word-break: break-word;
`
